import { render, staticRenderFns } from "./ArtigoEditar.vue?vue&type=template&id=d5619814"
import script from "./ArtigoEditar.vue?vue&type=script&lang=js"
export * from "./ArtigoEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports